import GalleryContainer from "../features/gallery/components/GalleryContainer";
import { pageShell } from "../styles/pageShell";

function GalleryPage() {
    return (
        <div className={pageShell.container}>
            <div className={pageShell.header}>
                <h2 className={pageShell.title}>メディアギャラリー</h2>
            </div>
            <div className={pageShell.card}>
                <GalleryContainer />
            </div>
        </div>
    );
}

export default GalleryPage;
